// Libraries
import { Box, SliderMark } from '@chakra-ui/react';
// Types
import { CustomMarkProps } from './CustomMark.types';

/**
 * The `CustomMark` component is a custom slider mark that displays a label.
 * The label is initially hidden and appears when the slider is active.
 *
 * @component
 * @param {CustomMarkProps} props - The props to configure the CustomMark component.
 * @param {string} props.label - The label to display on the slider mark.
 *
 * @returns {ReactElement} The rendered CustomMark component.
 */
export const CustomMark = ({ label }: CustomMarkProps) => (
  <SliderMark value={label} mt={1}>
    <Box
      fontSize='s'
      color='grey.100'
      mt={1.5}
      transform='translateX(-50%)'
      opacity='0'
      sx={{
        '.slider:active &': {
          opacity: '1',
        },
      }}
    >
      {label}
    </Box>
  </SliderMark>
);
